import tw, { styled } from 'twin.macro'
import { useTranslation } from '@i18n'
import Chip from '@components/DesignSystem/Chip'
import ChevronRightIcon from '@components/Icons/ChevronRightIcon'
import DownloadAppBanner from './DownloadAppBanner'
import { useState, useEffect } from 'react'

interface ArticleIntersectionProps {
  article: {
    title?: string
    content?: string
    publisher?: {
      name?: string
      photoUrl?: string
    }
    coverImage?: {
      croppedUrl?: string
    }
    publishedAt?: Date
  }
  openWebLink?: string
}

export function IntersectionArticle(props: ArticleIntersectionProps) {
  const { article, openWebLink } = props
  const { coverImage, title, content } = article
  const { t } = useTranslation('intersection')
  const handleOpenWebLinkOnClick = () => {
    document.cookie = 'openedWithWeb=;max-age=86400;path=/'
  }

  const [slogan, setSlogan] = useState('')

  useEffect(() => {
    const sloganLength: number = t(`slogan.length`) as any
    const sloganIndex = Math.floor(Math.random() * sloganLength)
    setSlogan(t(`slogan.${sloganIndex}`))
  }, [])

  return (
    <Container>
      <CoverImage>
        <img src={coverImage?.croppedUrl} />
      </CoverImage>
      <ContentArea>
        <TitleBlock>{title}</TitleBlock>
        <ContentBlock>{content}</ContentBlock>
      </ContentArea>
      <DownloadAppBanner
        openWebLink={openWebLink}
        slogan={slogan}
        buttonText={t(['downloadApp', '免費下載 APP'])}
      />
      <OpenWebLink as="a" href={openWebLink} onClick={handleOpenWebLinkOnClick}>
        {t(['openWeb', '網頁開啟'])}
        <ChevronRightIcon width="16" height="16" />
      </OpenWebLink>
    </Container>
  )
}

const Container = styled.div`
  height: 100vh;
  overflow: hidden;
  position: relative;
`

const CoverImage = styled.div`
  ${tw`w-screen relative`}
  padding-top: 56.25%;

  img {
    ${tw`w-full h-full object-cover absolute`}
    top: 0;
    left: 0;
  }
`

const ContentArea = styled.div`
  ${tw`p-4`}
`

const TitleBlock = styled.p`
  ${tw`text-black text-h4 overflow-hidden font-semibold`}
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  margin-bottom: 8px;

  line-height: 28px;
  letter-spacing: 0.5px;
`

const ContentBlock = styled.p`
  ${tw`text-gray-800 text-h5 overflow-hidden`}
  margin-bottom: 17px;

  line-height: 27px;
  letter-spacing: 0.25px;
`

const OpenWebLink = styled(Chip)`
  ${tw`text-gray-800 absolute flex`}
  top: 12px;
  right: 8px;
  background: rgba(247, 247, 247, 0.8);
  line-height: 1;
`
